import RedirectContainer from "../../../components/RedirectContainer";
import {
    Container,
    Row,
    Col,
    Button,
    Form,
    Table,
    Modal,
    InputGroup,
    Image
} from "react-bootstrap";
import SidebarPanelNavigation from "../../../components/SidebarPanelNavigation";
import { BsFillGridFill } from "react-icons/bs";
import { Formik, useFormik, Form as FormFormik, Field } from "formik";
import { IoIosAddCircle } from "react-icons/io";
import { MdDelete, MdEdit } from "react-icons/md";
import { useState, useEffect } from "react";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { TiInputChecked } from "react-icons/ti";
import {
    getAllDivugacao,
    AddPeople,
    deletePessoas,
    getDivulgacao,
    updatePessoas,
    searchPessoas,
    getCidades
} from "../../../services/api";
import getState, { statesList } from "../../../utils/uf";
import useNotification from "../../../contexts/notification";
import Select from "react-select"; // ✅ CERTO


function UpdatePartnerForm({ categoryId, onDone }) {
    const [loading, setLoading] = useState(true);
    const [initialValues, setInitialValues] = useState({
        name: "",
        description: "",
        state: "",
        city: "",
        image: undefined,
        id: null
    });

    const [cities, setCities] = useState([]);
    const { setMessage } = useNotification();

    const stateOptions = statesList.map((s) => ({
        value: s.id,
        label: s.name
    }));

    useEffect(() => {
        async function loadData() {
            try {
                const data = await getDivulgacao(categoryId);
                const partner = data.divulgacao[0];
                const uf = partner.city_state?.uf || "";
                const city = partner.city_state?.name || "";

                const cityList = uf ? await getCidades(uf) : [];

                setInitialValues({
                    id: partner.id,
                    name: partner.nome || "",
                    description: partner.description || "",
                    state: uf,
                    city: city,
                    image: undefined
                });

                setCities(cityList);
                setLoading(false);
            } catch (err) {
                setMessage({
                    error: true,
                    content: "Erro ao carregar os dados do parceiro.",
                });
            }
        }

        loadData();
    }, [categoryId, setMessage]);

    if (loading) return <LoadingIndicator />;

    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("description", values.description);
                formData.append("state", values.state);
                formData.append("city", values.city);

                if (values.image instanceof File) {
                    formData.append("image", values.image);
                }

                try {
                    await updatePessoas(formData, values.id);
                    setMessage({ error: false, content: "Parceiro atualizado com sucesso." });
                    onDone?.();
                } catch (err) {
                    setMessage({ error: true, content: "Erro ao atualizar parceiro." });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {(formik) => {
                const cityOptions = cities.map((city) => ({
                    label: city.name,
                    value: city.name
                }));

                return (
                    <FormFormik>
                        <Row className="mb-3">
                            <Col lg={12}>
                                <Form.Group controlId="name">
                                    <Form.Label>Nome Completo</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="Nome Completo"
                                        onChange={formik.handleChange}
                                        value={formik.values.name}
                                        isInvalid={formik.touched.name && !!formik.errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.name}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>



                            <Col md={6}>
                                <Form.Group controlId="state">
                                    <Form.Label>Estado</Form.Label>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        placeholder="Selecione o Estado"
                                        value={stateOptions.find((opt) => opt.value === formik.values.state) || null}
                                        onChange={async (selected) => {
                                            const uf = selected?.value || "";
                                            formik.setFieldValue("state", uf);
                                            formik.setFieldValue("city", "");
                                            const fetchedCities = await getCidades(uf);
                                            setCities(fetchedCities);
                                        }}
                                        onBlur={() => formik.setFieldTouched("state", true)}
                                        classNamePrefix="select"
                                    />
                                    {formik.touched.state && formik.errors.state && (
                                        <div className="text-danger mt-1">{formik.errors.state}</div>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="city">
                                    <Form.Label>Cidade</Form.Label>
                                    <Select
                                        name="city"
                                        options={cityOptions}
                                        placeholder={
                                            formik.values.state ? "Selecione uma Cidade" : "Selecione o Estado primeiro"
                                        }
                                        value={cityOptions.find((opt) => opt.value === formik.values.city) || null}
                                        onChange={(selected) =>
                                            formik.setFieldValue("city", selected?.value || "")
                                        }
                                        onBlur={() => formik.setFieldTouched("city", true)}
                                        isDisabled={!formik.values.state}
                                        classNamePrefix="select"
                                    />
                                    {formik.touched.city && formik.errors.city && (
                                        <div className="text-danger mt-1">{formik.errors.city}</div>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col lg={12}>
                                <Form.Group controlId="image">
                                    <Form.Label>Imagem</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/png, image/jpeg"
                                        onChange={(e) =>
                                            formik.setFieldValue("image", e.currentTarget.files[0])
                                        }
                                        isInvalid={formik.touched.image && !!formik.errors.image}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.image}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Button type="submit" disabled={formik.isSubmitting}>
                            ATUALIZAR
                            <TiInputChecked style={{ fontSize: "1.6em", marginLeft: 8 }} />
                        </Button>
                    </FormFormik>
                );
            }}
        </Formik>
    );
}

function AddPartnerModal(props) {
    const [loading, setLoading] = useState(false);
    const { setMessage } = useNotification();
    const [cities, setCities] = useState([]);

    const stateOptions = statesList.map((state) => ({
        value: state.id, // ex: 'CE'
        label: state.name // ex: 'Ceará'
    }));

    const formik = useFormik({
        initialValues: {
            name: "",
            state: "",
            city: "",
            image: undefined
        },
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("state", values.state);
                formData.append("city", values.city);
                if (values.image) {
                    formData.append("image", values.image);
                }

                await AddPeople(formData);
                setMessage({
                    error: false,
                    content: "Parceiro cadastrado com sucesso"
                });
                setLoading(false);
                props.onHide();
                formik.resetForm();
            } catch (err) {
                setLoading(false);
                setMessage({
                    error: true,
                    content: "Erro ao cadastrar parceiro"
                });
            }
        }
    });

    // 🔁 Carrega cidades ao mudar estado
    useEffect(() => {
        async function fetchCities() {
            if (!formik.values.state) return;
            const result = await getCidades(formik.values.state);
            setCities(result);
        }
        fetchCities();
    }, [formik.values.state]);

    // 🔁 Mapeia cidades para Select
    const cityOptions = cities.map((city) => ({
        value: city.name,
        label: city.name
    }));

    return (
        <Modal
            {...props}
            size="md"
            centered
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className="text-primary">Adicionar Pessoas</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={formik.handleSubmit}>
                    <Row className="mb-3">
                        <Col lg={12}>
                            <Form.Group controlId="name">
                                <Form.Label>Nome Completo *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="Digite o nome"
                                    onChange={formik.handleChange}
                                    value={formik.values.name || ""}
                                    isInvalid={formik.touched.name && !!formik.errors.name}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.name}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col sm={12} md={6}>
                            <Form.Group controlId="state">
                                <Form.Label>Estado *</Form.Label>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    placeholder="Selecione um Estado"
                                    value={
                                        stateOptions.find(
                                            (option) => option.value === formik.values.state
                                        ) || null
                                    }
                                    onChange={(selected) => {
                                        formik.setFieldValue("state", selected?.value || "");
                                        formik.setFieldValue("city", "");
                                    }}
                                    onBlur={() => formik.setFieldTouched("state", true)}
                                    classNamePrefix="select"
                                />
                                {formik.touched.state && formik.errors.state && (
                                    <div className="text-danger mt-1">
                                        {formik.errors.state}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>

                        <Col sm={12} md={6}>
                            <Form.Group controlId="city">
                                <Form.Label>Cidade *</Form.Label>
                                <Select
                                    name="city"
                                    options={cityOptions}
                                    placeholder={
                                        formik.values.state
                                            ? "Selecione uma Cidade"
                                            : "Selecione o Estado primeiro"
                                    }
                                    isDisabled={!formik.values.state}
                                    value={
                                        cityOptions.find(
                                            (option) => option.value === formik.values.city
                                        ) || null
                                    }
                                    onChange={(selected) => {
                                        formik.setFieldValue("city", selected?.value || "");
                                    }}
                                    onBlur={() => formik.setFieldTouched("city", true)}
                                    classNamePrefix="select"
                                />
                                {formik.touched.city && formik.errors.city && (
                                    <div className="text-danger mt-1">
                                        {formik.errors.city}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="image">
                                <Form.Label>Imagem *</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    accept="image/png, image/jpeg"
                                    onChange={(e) =>
                                        formik.setFieldValue("image", e.currentTarget.files[0])
                                    }
                                    isInvalid={formik.touched.image && formik.errors.image}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formik.errors.image}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Button type="submit" disabled={loading}>
                        SALVAR
                        <TiInputChecked style={{ fontSize: "1.6em", marginLeft: 8 }} />
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default function Partners() {
    const [query, setQuery] = useState("");
    const [data, setData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);

    const [showUpdateCategoryModal, setShowUpdateCategoryModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { setMessage } = useNotification();

    const refresh = () => {
        const error = {
            error: true,
            content: "Erro ao recarregar. Tente novamente mais tarde",
        };

        if (query) {
            searchPessoas(query).then(
                (data) => {
                    setData(data);
                },
                () => setMessage(error)
            );
        } else {
            getAllDivugacao().then(
                (data) => {
                    setData(data);
                },
                () => setMessage(error)
            );
        }
    };

    function handleQueryCategory(e) {
        e.preventDefault();
        searchPessoas(query).then((data) => {
            setData(data.divulgacaos || []);
        });
    }

    useEffect(() => {
        if (selectedCategory) {
            setShowUpdateCategoryModal(true);
        }
    }, [selectedCategory]);

    useEffect(() => {
        if (query.length === 0) {
            getAllDivugacao().then(
                (response) => {

                    setData(response);
                    setIsLoading(false);
                },
                () =>
                    setMessage({
                        error: true,
                        content: "Um erro ocorreu. Tente novamente mais tarde",
                    })
            );
        }
    }, [query, setMessage]);

    function UpdateCategoryModal(props) {
        return (
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <span className="text-primary">Adicionar Parceiro</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UpdatePartnerForm
                        categoryId={selectedCategory}
                        onDone={props.onHide}
                    />
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <>
            <RedirectContainer role="admin">
                <Container fluid>
                    <div>
                        <SidebarPanelNavigation isAdmin />
                        <div className="content-panel">
                            {isLoading && <LoadingIndicator />}
                            {!isLoading && (
                                <>
                                    <div className="py-3">
                                        <h5 className="text-primary mb-3 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0">
                                            <BsFillGridFill className="mr-2" />
                                            Divugação da Shoppe
                                        </h5>
                                    </div>

                                    <div className="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-between">
                                        <div>
                                            <Form >
                                                <Form.Group className="d-flex" controlId="">
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Buscar Pessoas"
                                                            onKeyUp={handleQueryCategory}
                                                            required
                                                            onChange={(e) => setQuery(e.target.value)}
                                                        />
                                                    </InputGroup>
                                                </Form.Group>
                                            </Form>
                                        </div>

                                        <div>
                                            <Button
                                                variant="primary"
                                                onClick={() => setShowAddCategoryModal(true)}
                                                className=" mr-md-3 mr-lg-3 mr-0 mr-sm-0 mb-2 mb-sm-2 mb-md-0 mb-lg-0"
                                            >
                                                <span className="mr-2">ADICIONAR</span>
                                                <IoIosAddCircle style={{ fontSize: "1.6em" }} />
                                            </Button>

                                            <AddPartnerModal
                                                show={showAddCategoryModal}
                                                onHide={() => {
                                                    setShowAddCategoryModal(false);
                                                    refresh();
                                                }}
                                            />
                                            <UpdateCategoryModal
                                                show={showUpdateCategoryModal}
                                                onHide={() => {
                                                    setShowUpdateCategoryModal(false);
                                                    setSelectedCategory(null);
                                                    refresh();
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <Row>
                                        <Col lg={12}>

                                            <Table striped bordered hover responsive size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>nome</th>
                                                        <th>Localidade</th>
                                                        <th>Imagem</th>

                                                        <th className="w-25">Ações</th>
                                                    </tr>
                                                </thead>

                                                {data.length === 0 && (
                                                    <h5 className="text-muted text-center my-5">
                                                        Sem resultados
                                                    </h5>
                                                )}
                                                <tbody>
                                                    {data.map((categories) => (
                                                        <tr key={categories.id} className="w-25">
                                                            <td>{categories.nome}</td>
                                                            <td>
                                                                {categories.city_state?.uf ?? ''}, {categories.city_state?.name ?? ''}
                                                            </td>

                                                            <td>
                                                                <Image
                                                                    src={(categories.image_url)}
                                                                    style={{ width: "100px" }}
                                                                />
                                                            </td>
                                                            <td className="d-flex">
                                                                <Button
                                                                    variant="warning"
                                                                    size="sm"
                                                                    className="text-white d-flex align-items-center mr-3"
                                                                    onClick={() => {
                                                                        setSelectedCategory(categories.id);
                                                                    }}
                                                                >
                                                                    <MdEdit style={{ fontSize: "1.4em" }} />
                                                                </Button>

                                                                <Button
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        let conf = window.confirm("Esta ação deletará o cartão fidelidade.");
                                                                        if (conf) {
                                                                            deletePessoas(categories).then(
                                                                                () => setMessage({
                                                                                    error: false,
                                                                                    content: "Categoria deletada com sucesso."
                                                                                }), () => setMessage({
                                                                                    error: true,
                                                                                    content: "Ocorreu um erro, tente novamente mais tarde."
                                                                                })
                                                                            )
                                                                            refresh();
                                                                        }
                                                                    }
                                                                    }
                                                                    variant="danger"
                                                                    className="text-white d-flex align-items-center"
                                                                >
                                                                    <MdDelete style={{ fontSize: "1.4em" }} />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            {/* <div className="d-flex justify-content-end">
                        <Pagination>
                          <Pagination.First />
                          <Pagination.Prev />
                          <Pagination.Item active>{1}</Pagination.Item>
                          <Pagination.Item>{2}</Pagination.Item>
                          <Pagination.Item>{3}</Pagination.Item>
                          <Pagination.Next />
                          <Pagination.Last />
                        </Pagination>
                      </div> */}
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    </div>
                </Container>
            </RedirectContainer>
        </>
    );
}
